import React from 'react';
import {connect} from "react-redux";
import $ from "jquery";
import {FormattedMessage, injectIntl} from "react-intl";

import {
  setShowUnlockCalculationsTutorial, setUnlockCalculationsTutorialFinished,
  setUnlockCalculationsTutorialStep
} from "../../actions/unlockCalculationsFunctions";
import UnlockCalculationsTutorialFunctions from "./unlockCalculationsTutorialFunctions";

class UnlockCalculationsTutorial extends UnlockCalculationsTutorialFunctions {

  constructor(props) {
    super(props);
    const {intl, fabricatorData} = this.props;
    this.state = {
      mainText: {
        0: intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.mainText1"}),
        1: intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.mainText2"}),
        2: fabricatorData.isLakesideSurfaces ? "Click here to submit" : intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.mainText3"}),
      },
      ringStyles: {
        left: 0,
        top: 0,
      },
      countertopButtonStyles: {},
      countertopButtonText: intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.countertopButtonText"}),
    };
  }

  componentDidMount = () => {
    this.checkCountertopButtonStep();
    $(".tutorial-step").fadeIn(300);
    setTimeout(() => {  // wait until countertop button calculates
      $(this.overlayElement).fadeIn(300);
    }, 300)
  };

  checkCountertopButtonStep = () => {
    const countertopSelector = ".selection-footer-list .selection-footer-list__item--countertop";
    const centerIslandCountertopSelector = ".selection-footer-list .selection-footer-list__item--center_island_countertop";
    const listSelector = ".selection-footer-list";
    const countertopButton = document.querySelector(countertopSelector) || document.querySelector(centerIslandCountertopSelector);
    const $list = $(listSelector);
    if (countertopButton) {
      if ($list) {
        $list.animate({scrollLeft: countertopButton.offsetLeft}, 0)
      }
      this.changeHighlightRingPosition(document.querySelector(countertopSelector) ? countertopSelector : centerIslandCountertopSelector);
      let countertopButtonStyles = {};
      const icon = countertopButton.querySelector(".selection-footer-list__item-icon");
      if (countertopButtonStyles) {
        const computed = window.getComputedStyle(icon);
        if (computed && computed.background) {
          countertopButtonStyles.background = computed.background;
        }
        if (computed && computed.backgroundSize) {
          countertopButtonStyles.backgroundSize = computed.backgroundSize;
        }
      }
      const text = countertopButton.querySelector(".selection-footer-list__item-text");
      const {intl} = this.props;
      this.setState({
        countertopButtonStyles,
        countertopButtonText: text ? text.innerText : intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.countertopButtonText"})
      })
    } else {
      this.handleNextStepClick(); // go to visualizer button
    }
  };

  getHighLightButton = () => {
    switch (this.props.unlockCalculationsTutorialStep) {
      case 0: {
        return (
          <button className="selection-footer-list__item selection-footer-list__item--countertop" onClick={this.handleNextStepClick}>
            <span className="selection-footer-list__item-icon" style={this.state.countertopButtonStyles}/>
            <span className="selection-footer-list__item-text">{this.state.countertopButtonText}</span>
          </button>
        )
      }
      case 1: {
        return <button className="selection-main__image-button selection-main__image-button--fullscreen"
                       onClick={this.handleNextStepClick}/>
      }
      case 2: {
        const selector = ".ui-button2.ui-button2--green.pulsating--green";
        const finalButton = document.querySelector(selector);
        const {intl} = this.props;
        return (
          <button className="ui-button2 ui-button2--green pulsating--green" onClick={this.handleNextStepClick}>
            {finalButton ? finalButton.innerText : intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.checkoutButtonDefaultText"})}
          </button>
        )
      }
      default:
        return null
    }
  };

  handleNextStepClick = () => {
    const nextStep = this.props.unlockCalculationsTutorialStep + 1
    if (nextStep === 3) {
      this.exitTutorial();
      return false
    }
    switch (nextStep) {
      case 1: {
        $(".tutorial-step").fadeOut(300, () => {
          this.changeHighlightRingPosition(".selection-main__image-button.selection-main__image-button--fullscreen");
          this.props.setUnlockCalculationsTutorialStep(nextStep);
          $(".tutorial-step").fadeIn(300);
        })
        break;
      }
      case 2: {
        $(".tutorial-step").fadeOut(300, () => {
          this.changeHighlightRingPosition(".ui-button2.ui-button2--green.pulsating--green");
          this.props.setUnlockCalculationsTutorialStep(nextStep);
          $(".tutorial-step").fadeIn(300);
        })
        break;
      }
      default:
        break;
    }
  };

  render() {
    const ringStyles = this.state.ringStyles;
    return (
      <div className={"tutorial-overlay tutorial-overlay--calculations"} ref={(node) => this.overlayElement = node}>
        <div className={"tutorial"}>
          <div className="tutorial-main tutorial-main--with-image">
            <div className={"tutorial-main__image tutorial-main__image--unlock--"+this.props.unlockCalculationsTutorialStep}/>
            <p className="tutorial-main__text bold">{this.state.mainText[this.props.unlockCalculationsTutorialStep]}</p>
            <div className="tutorial-main__buttons">
              <button className="ui-button3 ui-button3--green ui-button3--wide pulsating--green"
                      onClick={this.handleNextStepClick} id="tutorial-next">
                <FormattedMessage id="shoppingCart.unlockCalculationsTutorial.nextButton"/>
              </button>
            </div>
          </div>
          <span className={"tutorial-step__ring tutorial-step__ring--scale tutorial-step__ring--calculations-" + this.props.unlockCalculationsTutorialStep}
                style={{
                  "transform": "translate("+ringStyles.left +"px, "+ringStyles.top +"px)"
                }}/>
          <div className={"tutorial-step tutorial-step--" + this.props.unlockCalculationsTutorialStep} style={{
            left: ringStyles.left,
            top: ringStyles.top,
          }}>
            {this.getHighLightButton()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    unlockCalculationsTutorialStep: store.unlockCalculationsState.unlockCalculationsTutorialStep,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setUnlockCalculationsTutorialStep,
  setShowUnlockCalculationsTutorial,
  setUnlockCalculationsTutorialFinished
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UnlockCalculationsTutorial)
)
